import { render, staticRenderFns } from "./searchStatistics.vue?vue&type=template&id=3beb0f8e&scoped=true"
import script from "./searchStatistics.vue?vue&type=script&lang=js"
export * from "./searchStatistics.vue?vue&type=script&lang=js"
import style0 from "./searchStatistics.vue?vue&type=style&index=0&id=3beb0f8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3beb0f8e",
  null
  
)

export default component.exports